// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"6d14190e","275":"0eef2018"}[chunkId] + ".chunk.css";
};